<template>
	<div
		class="serenity__container-top"
		:style="
			`text-align: ${align}; width: ${width}; height: ${height}; padding-top: ${pt}; padding-bottom: ${pb}; padding-left: ${pl}; padding-right: ${pr}; padding: ${padding}; background: ${background}`
		"
	>
		<slot></slot>
	</div>
</template>

<script>
export default {
	props: {
		width: String,
		height: String,
		align: String,
		pt: String,
		pb: String,
		pl: String,
        pr: String,
        padding: String,
		background: String,
	},
};
</script>

<style lang="scss" scoped>
.serenity__container-top {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	width: 100%;
}
</style>
